import { createTheme } from '@mui/material/styles';

const createFrecallTheme = (mode = 'light') => {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: '#005f50',
        dark: '#004d40',
        light: '#47a18f',
      },
      secondary: {
        main: isDark ? '#d5dce0' : '#1f2328',
      },
      background: {
        default: isDark ? '#0f1413' : '#eef4f1',
        paper: isDark ? '#151d1b' : '#f8fbfa',
      },
      text: {
        primary: isDark ? '#edf2f0' : '#1f2328',
        secondary: isDark ? '#a8b3af' : '#5c656c',
      },
    },
    shape: {
      borderRadius: 14,
    },
    typography: {
      fontFamily: '"Avenir Next", Avenir, "Segoe UI", sans-serif',
      h4: {
        fontWeight: 700,
        letterSpacing: -0.45,
      },
      h5: {
        fontWeight: 650,
        letterSpacing: -0.25,
      },
      button: {
        textTransform: 'none',
        fontWeight: 600,
        letterSpacing: 0.1,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: isDark ? '#0f1413' : '#eef4f1',
            minHeight: '100dvh',
            WebkitTapHighlightColor: 'transparent',
          },
          "*": {
            boxSizing: 'border-box',
          },
          "@media (prefers-reduced-motion: reduce)": {
            "*": {
              animationDuration: "0.01ms !important",
              animationIterationCount: "1 !important",
              transitionDuration: "0.01ms !important",
              scrollBehavior: "auto !important",
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 14,
            borderColor: isDark ? 'rgba(132, 177, 162, 0.22)' : 'rgba(0, 77, 64, 0.14)',
            boxShadow: isDark ?
              '0 8px 18px rgba(0, 0, 0, 0.24)' :
              '0 6px 16px rgba(18, 30, 26, 0.10)',
          },
        },
      },
      MuiFab: {
        styleOverrides: {
          root: {
            width: 58,
            height: 58,
            boxShadow: '0 4px 10px rgba(0,0,0,0.14)',
            transition: 'all 160ms ease',
            '&:hover': {
              transform: 'translateY(-1px)',
            },
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 999,
            fontWeight: 600,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            minHeight: 40,
            transition: 'all 150ms ease',
          },
        },
      },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            '&.Mui-focusVisible': {
              outline: isDark ?
                '2px solid rgba(133, 196, 175, 0.72)' :
                '2px solid rgba(0, 95, 80, 0.72)',
              outlineOffset: 2,
            },
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 16,
          },
        },
      },
    },
  });
};

export default createFrecallTheme;
